export default {
  toUpperOnlyFirstLetter(str) {
    if (!str) return "";
    return str
      .trim()
      .replace(str[0], str[0].toUpperCase());
  },
  toUpperFirstLetter(str) {
    if (!str) return "";
    return str
      .trim()
      .toLowerCase()
      .replace(str[0], str[0].toUpperCase());
  }
};
